import React, { useState } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Button,
  Grid,
  Typography,
  Card as MuiCard,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import { spacing } from "@material-ui/system";
import APMaintenanceTable from "../../components/APMaintenanceTable";
import ApRegistrationWizard from "../../components/mantenimiento-ap/ApRegistrationWizard";

const Card = styled(MuiCard)(spacing);
const HeroCard = styled(Card)`
  overflow: hidden;
  border-radius: 24px;
  background: linear-gradient(135deg, #0b1324 0%, #1d4e89 54%, #38bdf8 100%);
  color: #fff;
  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.18);
`;

const SurfaceCard = styled(Card)`
  border-radius: 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.18);
`;

const ActionButton = styled(Button)`
  && {
    border-radius: 14px;
    padding: 12px 18px;
    box-shadow: none;
  }
`;

function ApMaintenance() {
  const [openWizard, setOpenWizard] = useState(false);

  const handleOpenWizard = () => {
    setOpenWizard(true);
  };

  const handleCloseWizard = () => {
    setOpenWizard(false);
  };

  return (
    <React.Fragment>
      <Helmet title="Mantenimiento de AP" />
      <HeroCard mb={6}>
        <CardContent>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={8}>
              <Box
                mb={2}
                display="inline-flex"
                px={2}
                py={1}
                borderRadius={999}
                style={{
                  background: "rgba(255,255,255,0.14)",
                  border: "1px solid rgba(255,255,255,0.16)",
                }}
              >
                <Typography variant="caption">
                  Infrastructure cockpit
                </Typography>
              </Box>
              <Typography variant="h2" gutterBottom>
                Mantenimiento de AP
              </Typography>
              <Typography variant="body1" style={{ opacity: 0.88 }}>
                Gestiona tus access points con una vista mas limpia, acceso
                directo a ubicacion, edicion y monitoreo operativo.
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid container justifyContent="flex-end">
                <Grid item>
                  <ActionButton
                    variant="contained"
                    style={{ background: "#fff", color: "#0f172a" }}
                    onClick={handleOpenWizard}
                  >
                    <AddIcon />
                    Agregar Access Point
                  </ActionButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </HeroCard>

      <SurfaceCard mb={6}>
        <CardContent>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <Typography variant="h4" gutterBottom>
                Inventario operativo
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Supervisa estado, tipo, pendientes y herramientas de gestion
                desde una tabla con mejor foco visual.
              </Typography>
            </Grid>
          </Grid>

          <Grid justifyContent="center" container spacing={10}>
            <Grid item xs={12}>
              <APMaintenanceTable />
            </Grid>
          </Grid>
        </CardContent>
      </SurfaceCard>

      {/* Dialog to show the wizard */}
      <Dialog
        open={openWizard}
        onClose={handleCloseWizard}
        maxWidth="md"
        fullWidth
        scroll="paper"
        PaperProps={{ style: { borderRadius: 24, maxHeight: "90vh" } }}
      >
        <DialogTitle>{"Agregar Access Point"}</DialogTitle>
        <DialogContent style={{ padding: 0, overflowY: "auto" }}>
          <ApRegistrationWizard onClose={handleCloseWizard} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseWizard} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ApMaintenance;
